import { Coords } from "types/app";

export const formatCoords = (coords: Coords) =>
  `Lat: ${coords[0].toFixed(6)}, Lng: ${coords[1].toFixed(6)}`;
